import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@devinforius/i-essentials';
import * as TRANSLATIONS from 'src/assets/translations/fr.json';

type Primitive = string | number | boolean | null | undefined | symbol | bigint;

type DotPrefix<T extends string> = T extends '' ? '' : `.${T}`;

export type TranslationKey = DotNestedKeys<typeof TRANSLATIONS>;

export type DotNestedKeys<T> = T extends Primitive
  ? ''
  : T extends readonly any[]
    ? ''
    : {
        [K in Extract<keyof T, string>]: T[K] extends Primitive ? K : K | `${K}${DotPrefix<DotNestedKeys<T[K]>>}`;
      }[Extract<keyof T, string>];

@Injectable({
  providedIn: 'root',
})
export class Translater {
  private readonly service = inject(TranslateService);
  private readonly dict = TRANSLATIONS;

  public translates<K extends TranslationKey>(key: K, params?: Record<string, string | number>): string {
    const value = this.getByPath(this.dict, key as string);
    return typeof value === 'string' ? this.service.translate(value, params) : (key as string);
  }

  private getByPath(obj: unknown, path: string): unknown {
    return path.split('.').reduce<unknown>((acc, part) => {
      if (acc && typeof acc === 'object' && part in (acc as any)) {
        return (acc as any)[part];
      }
      return undefined;
    }, obj);
  }
}
